import { ConfigItem, WebsiteItem, ContractPriceItem } from "@/types";
import { PreHangOptions as PhOptions } from "./ph-options";
import { PreHangSelections as PhSelections } from "./ph-selections";
import { PreHangCartOptions } from "@/types/preHang";
import { PrehangStandards } from "./ph-standards";

export class PreHang {
    private door: ConfigItem | WebsiteItem | ContractPriceItem
    private activeIndex = 0
    private projectId: number
    public preHangSelections: PhSelections[] = []
    public cartPreHangOptions: PreHangCartOptions[] = []
    private options: PhOptions
    private loaded = false
    private isContractDoor = false
    private isBifoldDoor = false
    private isFireOrExteriorDoor = false
    private Standards: PrehangStandards
    public availableForms: String[]

    public constructor(doorItem: ConfigItem | WebsiteItem | ContractPriceItem, projectId: number) {
        this.door = doorItem
        this.isContractDoor = !!(this.door as ContractPriceItem).contractPrice?.partNumber
        this.isBifoldDoor = (this.door.name.toLowerCase().includes('bifold'))
        this.isFireOrExteriorDoor = (this.door.name.toLowerCase().includes('fire') || this.door.name.toLowerCase().includes('exterior'))
        this.availableForms = this.buildAvailableForms()
        this.Standards = new PrehangStandards(this.isFireOrExteriorDoor)
        this.projectId = projectId
        this.options = new PhOptions(this.door)
        this.tryInit()
    }

    private tryInit() {
        if(this.options.isLoaded()) {
            this.initPreHangSelections()
        } else {
            setTimeout(() => {
                this.tryInit()
            }, 500)
        }
    }

    private initPreHangSelections() {
        if(this.door?.preHangOptions) {
            this.door?.preHangOptions.forEach(set => {
                this.preHangSelections.push(new PhSelections(this.projectId, this.options, this.Standards, this.isContractDoor, this.isBifoldDoor, this.isFireOrExteriorDoor, 'path', set))
            })
        }
        if(this.preHangSelections.length == 0) {
            this.addNewPreHang()
        }
        this.loaded = true
        this.updateCartPreHangOptions()
    }

    private buildAvailableForms() {
        let forms
        if(this.isBifoldDoor) forms = ['jambs']
        else if(this.isFireOrExteriorDoor) forms = ['machine']
        else forms = ['prehang','machine','jambs']
        return forms
    }

    public updateCartPreHangOptions() {
        const temp: PreHangCartOptions[] = []

        this.preHangSelections.forEach(ph => {
            const result = ph.buildCartOptions()
            if(result) temp.push(result)
        })
        this.cartPreHangOptions = temp
    }

    public getActiveSelections() {
        return this.preHangSelections[this.activeIndex]
    }

    public getActiveErrors() {
        return this.preHangSelections[this.activeIndex].errors
    }

    public getActiveIsEmpty() {
        return this.preHangSelections[this.activeIndex].isEmpty
    }

    public getActiveForm() {
        return this.preHangSelections[this.activeIndex].getActiveForm()
    }

    public updateActiveIndex(i: number) {
        if(this.preHangSelections[i]) {
            this.activeIndex = i
        } else {
            console.log(`Error: No preHangSelection ${i} exists.`)
        }
    }

    public getActiveIndex() {
        return this.activeIndex
    }

    public addNewPreHang(path: 'path'|'prehang'|'machine'|'jambs' = 'path') {
        this.preHangSelections.push(new PhSelections(this.projectId, this.options, this.Standards, this.isContractDoor, this.isBifoldDoor, this.isFireOrExteriorDoor, path))
        this.activeIndex = this.preHangSelections.length - 1
    }

    public isLoaded() {
        return this.loaded
    }
}